import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ForgetPassword from '../pages/ForgetPassword';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Overview from '../pages/Overview';
import ResetPassword from '../pages/ResetPassword';
import ConfirmSuccess from '../pages/ConfirmSuccess';
import MarketPricedb from '../pages/MarketPricedb';
import Insights from '../pages/Insights';
import CekHarga from '../pages/CekHarga';
import CekPrice from '../pages/CekPrice';
import FindPrice from '../pages/FindPrice';
import UnderMaintenance from '../pages/UnderMaintenance';
import InternalServerError from '../pages/InternalServerError';
import NotFound from '../pages/NotFound';
import Profile from '../pages/Profile';
import Activation from '../pages/Activation';
import LoginModal from '../components/LoginModal';
import PremiumModal from '../components/PremiumModal';
import ExtendPremiumModal from '../components/ExtendPremiumModal';
import PopularOverview from '../pages/PopularOverview';
import TermsCondition from '../pages/TermsCondition';
import amplitude from 'amplitude-js';
import useCheckIbidLogin from '../hooks/useCheckIbidLogin';

const Routes = () => {

  amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_TOKEN, {
    saveEvents: true,
    includeUtm: true,
    includeReferrer: true,
    disableCookies: false,
  });

  useCheckIbidLogin({

    defaultLoading: true,
  });

  return (
    <Router>
      <LoginModal />
      <PremiumModal />
      <ExtendPremiumModal />

      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        <Route path="/lupa-kata-sandi">
          <ForgetPassword />
        </Route>
        <Route path="/users/register/active">
          <Activation />
        </Route>
        <Route path="/reset-password/:key">
          <ResetPassword />
        </Route>
        <Route path="/register-email-426-qwljP1hNtk4Jkb2CQPUXkD57TDOptYl5">
          <ConfirmSuccess />
        </Route>
        <Route path="/marketprice-db">
          <MarketPricedb />
        </Route>
        <Route path="/insights">
          <Insights />
        </Route>
        <Route path="/Cari-harga-kendaraan">
          <FindPrice />
        </Route>
        <Route path="/cek-harga-kendaraan">
          <CekHarga />
        </Route>
        <Route path="/check-price">
          <CekPrice />
        </Route>
        <Route path="/popular">
          <PopularOverview />
        </Route>
        <Route path="/under-maintenance">
          <UnderMaintenance />
        </Route>
        <Route path="/internal-server-error">
          <InternalServerError />
        </Route>
        <Route path="/not-found">
          <NotFound />
        </Route>
        <Route path="/dashboard/profile">
          <Profile />
        </Route>
        <Route path="/syarat-ketentuan">
          <TermsCondition />
        </Route>
        <Route exact path="/">
          <Overview />
        </Route>
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
